import { render, staticRenderFns } from "./news.vue?vue&type=template&id=e78f9bcc&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./news.vue?vue&type=style&index=1&id=e78f9bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78f9bcc",
  null
  
)

export default component.exports